import Home from "./components/pages/Home/index.js";
import React from "../_snowpack/pkg/react.js";
import {StockContextProvider} from "./context/StockContext.js";
function App() {
  return /* @__PURE__ */ React.createElement(StockContextProvider, null, /* @__PURE__ */ React.createElement(Home, null));
}
export default App;
